/**
 * Creates a GoogleMap map as a component
 * The Map could be personalized with the parameter below.
 *
 * @param   {Array.<Object>}    markers                     Array of Objects with the markers, REQUIRED
 * @param   {string}            markers[].lat               Latitude of the marker
 * @param   {string}            markers[].lng               Longitude of the marker
 * @param   {string}            markers[].messageText       Message of the marker's textbox
 * @param   {string}            markers[].messageTitle      Title of the marker's textbox
 * @param   {boolean}           markers.isOpen              Shows or hides the textbox at start
 * @param   {boolean}           isMarkerShown               Shows markers in the map
 * @param   {number}            defaultZoom                 Initial zoom of the map
 * @param   {Object}            defaultCenter               Object with the initial location of the map
 * @param   {string}            defaultCenter.lat           Latitude of the defaultCenter
 * @param   {string}            defaultCenter.lng           Longitude of the defaultCenter
 * @param   {boolean}           streetViewControl           [Enables/Disables the streetViewControl]
 * @param   {boolean}           mapTypeControl              [Enables/Disables the mapTypeControl]
 * @param   {boolean}           zoomControl                 [Enables/Disables the zoomControl]
 * @param   {boolean}           rotateControl               [Enables/Disables the rotateControl]
 * @param   {boolean}           scaleControl                [Enables/Disables the scaleControl]
 * @param   {boolean}           fullscreenControl           [Enables/Disables the fullscreenControl]
 * @param   {requestCallback}   onMarkerClick               [Function to handle the clicks of the markers]
 */

/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { compose, withProps } from 'recompose'
import { Link } from 'react-router-dom'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps'

/**
 *     Import
 *     - Components
 */
import googleMap from '../../../config/googleMaps'
import { ViewIcon } from '../../../images/icons/View/View'

/**
 *     Import
 *     - Styles
 */
import './styles/GoogleMap.css'
const styles = require('./styles/custom_map_styles.json')

const marker = googleMap.marker_icon
const CollectionMaker = googleMap.c_marker_icon
const museumsMaker = googleMap.m_marker_icon
const dealersMaker = googleMap.d_marker_icon
const wineMaker = googleMap.w_marker_icon

/**
 * Generates all the markes passed as props
 *
 * @param {*} markersArray
 * @param {*} props
 * @returns ReactDOM
 */

let generateMarkers = (markersArray: any, props: any) => {

    return markersArray.map((MarkerElement, index) => {
        // console.log(MarkerElement, props)
        if (props.Collectables === false && MarkerElement.policyType.isCollectors) {
            return null
        }
        if (props.art === false && !MarkerElement.policyType.isCollectors && !MarkerElement.policyType.isMuseums &&
            !MarkerElement.policyType.isDealersStock) {
            return null
        }
        if (props.museums === false && MarkerElement.policyType.isMuseums) {
            return null
        }
        if (props.dealers === false && MarkerElement.policyType.isDealersStock) {
            return null
        }
        if (props.wine === false && MarkerElement.policyType.isWineSpirits) {
            return null
        }
        return (
            <Marker
                icon={'data:image/svg+xml;charset=UTF-8,' + (MarkerElement.policyType.isCollectors ?
                    encodeURIComponent(CollectionMaker) : MarkerElement.policyType.isMuseums ?
                        encodeURIComponent(museumsMaker) : MarkerElement.policyType.isDealersStock ?
                            encodeURIComponent(dealersMaker) : MarkerElement.policyType.isWineSpirits ?
                                encodeURIComponent(wineMaker) : encodeURIComponent(marker))
                }
                position={MarkerElement}
                onClick={() => { props.onMarkerClick('open', index) }}
                key={index}
            >
                {(MarkerElement.isOpen) ? (<div>
                    <InfoWindow onCloseClick={() => { props.onMarkerClick('close', index) }}>
                        <div className="message-box">
                            <div className="message-box__title">{MarkerElement.messageTitle}</div>
                            <div className="message-box__content">
                                <div>
                                    Premium:
                                </div>
                                <div>
                                    &pound;{MarkerElement.messageText}
                                </div>
                                <div>
                                    <Link to={`/clients/policies/view/${MarkerElement.id}`}>
                                        <ViewIcon />
                                    </Link>
                                </div>
                                <div className="post_code">
                                    {(MarkerElement.postCode) ? MarkerElement.postCode : null}
                                </div>

                            </div>
                        </div>
                    </InfoWindow>
                </div>) : null}

            </Marker>
        )
    })
}

export const GoogleMapComponent = compose(
    withProps({
        googleMapURL: googleMap.url + '?key=' + googleMap.api_key,
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `100%` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap
)((props) =>
(
    <GoogleMap
        defaultZoom={props.defaultZoom ? props.defaultZoom : 7}
        defaultCenter={props.defaultCenter ? props.defaultCenter : { lat: 51.449749, lng: -0.967350 }}
        defaultOptions={
            {
                styles: styles,
                streetViewControl: props.streetViewControl ? props.streetViewControl : false,
                mapTypeControl: props.mapTypeControl ? props.mapTypeControl : false,
                zoomControl: props.zoomControl ? props.zoomControl : true,
                rotateControl: props.rotateControl ? props.rotateControl : false,
                scaleControl: props.scaleControl ? props.scaleControl : false,
                fullscreenControl: props.fullscreenControl ? props.fullscreenControl : false,
            }
        }
    >
        {props.isMarkerShown ? generateMarkers(props.markers, props) : null}
    </GoogleMap>
))



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/GoogleMap/GoogleMap.tsx